export default __webpack_public_path__ + "static/media/check.b14e1960.svg";